import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';
import { syncedResourceAllocationFragment } from '~/modules/resourcing/common/fragments';

export const REMOVE_RESOURCE_USER_TASK_ASSIGNMENT = gql`
  mutation removeResourceUserTaskAssignment(
    $input: RemoveResourceUserTaskAssignmentInput!
  ) {
    removeResourceUserTaskAssignment(input: $input) {
      userId
      syncedResourceAllocation {
        ...SyncedResourceAllocation
      }
    }
  }
  ${syncedResourceAllocationFragment}
`;

export const useRemoveResourceUserTaskAssignment = ({
  refetchQueries,
  updateCache
} = {}) => {
  const [removeResourceUserTaskAssignment, { data, loading }] = useMutation(
    REMOVE_RESOURCE_USER_TASK_ASSIGNMENT
  );

  const removeResourceUserTaskAssignmentCallback = useCallback(
    ({ userId, projectId, taskId }) =>
      removeResourceUserTaskAssignment({
        variables: {
          input: {
            userId,
            projectId,
            taskId
          }
        },
        update: updateCache,
        refetchQueries
      }),
    [refetchQueries, removeResourceUserTaskAssignment, updateCache]
  );

  return {
    removeResourceUserTaskAssignment: removeResourceUserTaskAssignmentCallback,
    data,
    loading
  };
};

export default useRemoveResourceUserTaskAssignment;
